import { render, staticRenderFns } from "./SalesDashboard.vue?vue&type=template&id=f3877916&scoped=true&"
import script from "./SalesDashboard.vue?vue&type=script&lang=js&"
export * from "./SalesDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SalesDashboard.vue?vue&type=style&index=0&id=f3877916&scoped=true&lang=css&"
import style1 from "./SalesDashboard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3877916",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VChip,VCol,VContainer,VDataTable,VIcon,VImg,VRow,VSpacer})
